import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { SupportDialogComponent } from '../support-dialog/support-dialog.component';
import { UserInfoComponent } from './components/user-info/user-info.component';
import { NavigationComponent } from './components/navigation/navigation.component';
import { HeaderSearchComponent } from './components/header-search/header-search.component';
@Component({
  selector: 'app-header',
  imports: [TranslateModule, MatIconModule, RouterModule, UserInfoComponent, NavigationComponent, HeaderSearchComponent],
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  private readonly dialog: MatDialog = inject(MatDialog);

  protected openSupportDialog(): void {
    this.dialog.open(SupportDialogComponent, {
      minWidth: '600px',
      width: '50vw',
      maxHeight: '90vh'
    });
  }
}
